


























































import Vue, { PropType } from "vue";
import { Messages } from "@/constants/messages";
export default Vue.extend({
  name: "DropdownSelector",
  data(): {
    itemsSelected: string[];
    mess: any;
    areMaxItemsSelected: boolean;
    errorType: string;
  } {
    return {
      itemsSelected: [],
      areMaxItemsSelected: false,
      errorType: "",
      mess: Messages,
    };
  },
  created() {
    if (this.itemSelectedUpdate) {
      this.itemsSelected = this.itemSelectedUpdate;
    }
  },
  watch: {
    itemsSelected(itemsSelected: string[]): void {
      this.areMaxItemsSelected = itemsSelected.length >= this.maxItemsSelected;
    },
  },
  methods: {
    disableItem(valueItem: string): boolean {
      if (this.areMaxItemsSelected) {
        if (!this.itemsSelected.includes(valueItem)) {
          return true;
        }
      }
      return false;
    },
    validateField(): boolean {
      const minValuesSelected =
        this.itemsSelected.length >= this.minItemsSelected;
      const notMoreThanMaxNumber = !(
        this.itemsSelected.length > this.maxItemsSelected
      );
      if (minValuesSelected && notMoreThanMaxNumber) {
        this.errorType = "";
        this.$emit("categoriesSelected", this.itemsSelected);
        return true;
      } else {
        this.errorType = "is-danger";
        return false;
      }
    },
  },
  props: {
    items: {
      type: Array,
    },
    placeholder: {
      type: String,
      default: "",
    },
    tooltipText: {
      type: String,
      default: "",
    },
    maxItemsSelected: {
      type: Number,
      default: 1,
    },
    minItemsSelected: {
      type: Number,
      default: 1,
    },
    itemSelectedUpdate: {
      type: Array as PropType<string[]>,
    },
  },
});
